export default "__VITE_ASSET__m3mm6I_x__"